"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendUp = function TrendUp() {
  return _react2.default.createElement(
    "g",
    { id: "trend-up" },
    _react2.default.createElement("path", {
      d: "M498.703704,176.648148 C502.037037,157.759259 489.351852,139.888889 470.555556,136.555556 C451.759259,133.222222 433.703704,145.814815 430.37037,164.703704 C428.888889,173.314815 430.740741,181.740741 435,188.685185 C305.925926,337.759259 137.592593,340.814815 68.7962963,334.703704 C66.0185185,321.185185 55.2777778,310.074074 40.8333333,307.481481 C21.9444444,304.148148 3.98148148,316.740741 0.648148148,335.62963 C-2.68518519,354.518519 9.90740741,372.481481 28.7962963,375.814815 C44.0740741,378.5 58.7962963,370.537037 65.462963,357.481481 C138.425926,364.055556 316.759259,360.907407 452.962963,203.222222 C454.722222,203.777778 456.574074,204.425926 458.518519,204.796296 C477.314815,208.12963 495.37037,195.537037 498.703704,176.648148 Z",
      id: "Shape"
    })
  );
};

exports.default = TrendUp;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendUp.js
// module id = 3004
// module chunks = 4